/* tslint:disable */
export const LocalesKeys = {
  "bookedAllDay": "bookedAllDay",
  "bookedUntil": "bookedUntil",
  "loading": "loading",
  "pickAProvider": "pickAProvider",
  "google": "google",
  "office": "office",
  "nbRoomsAvailable": "nbRoomsAvailable",
  "availableAt": "availableAt",
  "presenterModalTitle": "presenterModalTitle",
  "presenterStepTitle": "presenterStepTitle",
  "presenterStep1": "presenterStep1",
  "presenterStep3": "presenterStep3",
  "inviteModalTitle": "inviteModalTitle",
  "inviteRecipients": "inviteRecipients",
  "inviteRecipientsHint": "inviteRecipientsHint",
  "inviteSenderName": "inviteSenderName",
  "inviteSenderNameHint": "inviteSenderNameHint",
  "inviteSend": "inviteSend",
  "inviteError": "inviteError",
  "inviteClose": "inviteClose",
  "inviteToJoin": "inviteToJoin",
  "inviteSentTitle": "inviteSentTitle",
  "inviteSentSubTitle": "inviteSentSubTitle",
  "joinStepTitle": "joinStepTitle",
  "joinStep1": "joinStep1",
  "joinStep2": "joinStep2",
  "joinToInvite": "joinToInvite",
  "supportModalTitle": "supportModalTitle",
  "backText": "backText",
  "ok": "ok",
  "home": "home",
  "forward": "forward",
  "startOrJoin": "startOrJoin",
  "calendarStartOrJoin": "calendarStartOrJoin",
  "joinMeetingInputPlaceholder": "joinMeetingInputPlaceholder",
  "joinMeetingInputPlaceholderLine1": "joinMeetingInputPlaceholderLine1",
  "joinMeetingInputPlaceholderLine2": "joinMeetingInputPlaceholderLine2",
  "invalidMeeting": "invalidMeeting",
  "inValidMeetingIdHint": "inValidMeetingIdHint",
  "inValidMeetingNameHint": "inValidMeetingNameHint",
  "enterMeetingExample": "enterMeetingExample",
  "startRoomsMeeting": "startRoomsMeeting",
  "calendarStartRoomsMeeting": "calendarStartRoomsMeeting",
  "startAdHoc": "startAdHoc",
  "start": "start",
  "oopsError": "oopsError",
  "activationTitle": "activationTitle",
  "activationDescription1": "activationDescription1",
  "activationDescription2": "activationDescription2",
  "activationDescription3": "activationDescription3",
  "welcomeTitle": "welcomeTitle",
  "welcomeDescription": "welcomeDescription",
  "welcomeDeviceSelection": "welcomeDeviceSelection",
  "youAreIn": "youAreIn",
  "deviceNameLabel": "deviceNameLabel",
  "deviceNamePlaceholder": "deviceNamePlaceholder",
  "deviceNameHint": "deviceNameHint",
  "deviceTimezoneLabel": "deviceTimezoneLabel",
  "deviceWebcamLabel": "deviceWebcamLabel",
  "deviceCameraLabel": "deviceCameraLabel",
  "deviceMicroLabel": "deviceMicroLabel",
  "deviceAudioLabel": "deviceAudioLabel",
  "deviceCameraName": "deviceCameraName",
  "deviceMicroName": "deviceMicroName",
  "deviceAudioName": "deviceAudioName",
  "save": "save",
  "screenSharingInstrunction": "screenSharingInstrunction",
  "settingsScreenTitle": "settingsScreenTitle",
  "timeZone": "timeZone",
  "getStartedLink": "getStartedLink",
  "capitalVersion": "capitalVersion",
  "chromeVersion": "chromeVersion",
  "restart": "restart",
  "restartDescription": "restartDescription",
  "cancel": "cancel",
  "restartDeviceHeader": "restartDeviceHeader",
  "restartDeviceDescription1": "restartDeviceDescription1",
  "restartDeviceDescription2": "restartDeviceDescription2",
  "tryDifferentMeeting": "tryDifferentMeeting",
  "close": "close",
  "entitlementExpiredHeader": "entitlementExpiredHeader",
  "entitlementExpiredDescription1": "entitlementExpiredDescription1",
  "entitlementExpiredDescription2": "entitlementExpiredDescription2",
  "entitlementExpiredLink": "entitlementExpiredLink",
  "presentMeetingHeader": "presentMeetingHeader",
  "presentMeetingMessage1": "presentMeetingMessage1",
  "presentMeetingMessage2": "presentMeetingMessage2",
  "offlineNotificationHeader": "offlineNotificationHeader",
  "offlineNotification": "offlineNotification",
  "onlineNotificationHeader": "onlineNotificationHeader",
  "onlineNotification": "onlineNotification",
  "serviceUnavailable": "serviceUnavailable",
  "contentSharingWrappingUp": "contentSharingWrappingUp",
  "contentSharingReadyTitle": "contentSharingReadyTitle",
  "contentSharingReadyText": "contentSharingReadyText",
  "end": "end",
  "endPresentationModalTitle": "endPresentationModalTitle",
  "endPresentationModalText": "endPresentationModalText",
  "endPresentation": "endPresentation",
  "connectionLostHeader": "connectionLostHeader",
  "connectionLostDescription": "connectionLostDescription",
  "deviceErrorDescription": "deviceErrorDescription",
  "presentationCodeErrorNotificationHeader": "presentationCodeErrorNotificationHeader",
  "presentationCodeErrorNotificationText": "presentationCodeErrorNotificationText",
  "presentationCodeErrorRetryLinkText": "presentationCodeErrorRetryLinkText",
  "deviceErrorHeader": "deviceErrorHeader",
  "userbackHeader": "userbackHeader",
  "resumePresentation": "resumePresentation",
  "devicebackHeader": "devicebackHeader",
  "leave": "leave",
  "attendeeLeaveModalTitle": "attendeeLeaveModalTitle",
  "attendeeLeaveModalSubtitle": "attendeeLeaveModalSubtitle",
  "exitFullscreenHint": "exitFullscreenHint",
  "browserIdleCountdownInSeconds": "browserIdleCountdownInSeconds",
  "newTab": "newTab",
  "newTabContextMenu": "newTabContextMenu",
  "meetingRunningModalTitle": "meetingRunningModalTitle",
  "meetingRunningModalSubtitle1": "meetingRunningModalSubtitle1",
  "meetingRunningModalSubtitle2": "meetingRunningModalSubtitle2",
  "meetingRunningModalSubtitle2Scheduled": "meetingRunningModalSubtitle2Scheduled",
  "joinRunning": "joinRunning",
  "startNewMeeting": "startNewMeeting",
  "startScheduledMeeting": "startScheduledMeeting",
  "yes": "yes",
  "no": "no",
  "confirmKillModalTitle": "confirmKillModalTitle",
  "confirmKillModalSubtitle": "confirmKillModalSubtitle",
  "confirmKillModalSubtitleScheduled": "confirmKillModalSubtitleScheduled",
  "happeningToday": "happeningToday",
  "inHoursAndMinutes": "inHoursAndMinutes",
  "inMinutes": "inMinutes",
  "inHours": "inHours",
  "durationInHoursAndMinutes": "durationInHoursAndMinutes",
  "durationInMinutes": "durationInMinutes",
  "durationInHours": "durationInHours",
  "now": "now",
  "join": "join",
  "chooseYourLanguage": "chooseYourLanguage",
  "german": "german",
  "english": "english",
  "french": "french",
  "italian": "italian",
  "spanish": "spanish",
  "portuguese": "portuguese",
  "deviceLanguage": "deviceLanguage",
  "abouttitle": "abouttitle",
  "restarttitle": "restarttitle",
  "restartdesc": "restartdesc",
  "restartdescNuc": "restartdescNuc",
  "clickToShare": "clickToShare",
  "next": "next",
  "system": "system",
  "location": "location",
  "audio": "audio",
  "video": "video",
  "hangoutsBackToHomeTextStart": "hangoutsBackToHomeTextStart",
  "hangoutsBackToHomeTextLink": "hangoutsBackToHomeTextLink",
  "hangoutsBackToHomeTextEnd": "hangoutsBackToHomeTextEnd",
  "reservedBy": "reservedBy",
  "privateMeeting": "privateMeeting",
  "availableWholeDay": "availableWholeDay",
  "availableHours": "availableHours",
  "adHocTimeOpen": "adHocTimeOpen",
  "gotomeetingid": "gotomeetingid",
  "googlemeetid": "googlemeetid",
  "serialNumber": "serialNumber",
  "notAvailable": "notAvailable",
  "inAppBrowser": "inAppBrowser",
  "enterFullscreen": "enterFullscreen",
  "exitFullscreen": "exitFullscreen",
  "unresponsiveTitle": "unresponsiveTitle",
  "unresponsiveSubtitle": "unresponsiveSubtitle",
  "unresponsiveKillMeeting": "unresponsiveKillMeeting",
  "goBack": "goBack",
  "goForward": "goForward",
  "reloadPage": "reloadPage",
  "addressBarLoadPage": "addressBarLoadPage",
  "bookmarkPage": "bookmarkPage",
  "removeBookmark": "removeBookmark",
  "closeTab": "closeTab",
  "closeBrowser": "closeBrowser",
  "showBookmarks": "showBookmarks",
  "hideBookmarks": "hideBookmarks",
  "deleteBookmark": "deleteBookmark",
  "inAppBrowserHeader": "inAppBrowserHeader",
  "openTheBrowser": "openTheBrowser",
  "deviceDisplayModeLabel": "deviceDisplayModeLabel",
  "mirrorScreen": "mirrorScreen",
  "dualScreen": "dualScreen",
  "pageNotAvailable": "pageNotAvailable",
  "allDayEvent": "allDayEvent",
  "free": "free",
  "for": "for",
  "forXMinutes": "forXMinutes",
  "forXMinutes_plural": "forXMinutes_plural",
  "sayOrTouchToStart": "sayOrTouchToStart",
  "call": "call",
  "startNew": "startNew",
  "meetings": "meetings",
  "sunday": "sunday",
  "monday": "monday",
  "tuesday": "tuesday",
  "wednesday": "wednesday",
  "thursday": "thursday",
  "friday": "friday",
  "saturday": "saturday",
  "january": "january",
  "february": "february",
  "march": "march",
  "april": "april",
  "may": "may",
  "june": "june",
  "july": "july",
  "august": "august",
  "september": "september",
  "october": "october",
  "november": "november",
  "december": "december",
  "am": "am",
  "pm": "pm",
  "hours": "hours",
  "hours_plural": "hours_plural",
  "minutes": "minutes",
  "minutes_plural": "minutes_plural",
  "in": "in",
  "remaining": "remaining",
  "over": "over",
  "ago": "ago",
  "gtmIdLabel": "gtmIdLabel",
  "noMeetings": "noMeetings",
  "participant": "participant",
  "participants": "participants",
  "meetingInfo": "meetingInfo",
  "invite": "invite",
  "sendReminder": "sendReminder",
  "submit": "submit",
  "emailAddress": "emailAddress",
  "password": "password",
  "invalidEmailAddress": "invalidEmailAddress",
  "userIsCoOrganizer": "userIsCoOrganizer",
  "waitingRoom": "waitingRoom",
  "invalidCredentials": "invalidCredentials",
  "meetingIdOrName": "meetingIdOrName",
  "meetingIdError": "meetingIdError",
  "upcoming": "upcoming",
  "meetNow": "meetNow",
  "startMeeting": "startMeeting",
  "go": "go",
  "classicUIStartOrJoin": "classicUIStartOrJoin",
  "present": "present",
  "navigateTheWeb": "navigateTheWeb",
  "openWebBrowser": "openWebBrowser",
  "presentColon": "presentColon",
  "calendarFeatureInfoHeader": "calendarFeatureInfoHeader",
  "calendarFeatureInfoText1": "calendarFeatureInfoText1",
  "calendarFeatureInfoText2": "calendarFeatureInfoText2",
  "calendarFeatureInfoAskAdmin": "calendarFeatureInfoAskAdmin",
  "renewSubscriptionLinkText": "renewSubscriptionLinkText",
  "renewSubscriptionDetailHeader": "renewSubscriptionDetailHeader",
  "renewSubscriptionDetailDescription1": "renewSubscriptionDetailDescription1",
  "renewSubscriptionDetailDescription2": "renewSubscriptionDetailDescription2",
  "reset": "reset",
  "zoomToolTip": "zoomToolTip",
  "unexpectedError": "unexpectedError",
  "unexpectedErrorSuggestion": "unexpectedErrorSuggestion",
  "restartError": "restartError",
  "mute": "mute",
  "unmute": "unmute",
  "makePresenter": "makePresenter",
  "makeOrganizer": "makeOrganizer",
  "excuse": "excuse",
  "excuseConfirmTitle": "excuseConfirmTitle",
  "excuseConfirmText": "excuseConfirmText",
  "organizer": "organizer",
  "organizer_plural": "organizer_plural",
  "signIn": "signIn",
  "enterMessage": "enterMessage",
  "send": "send",
  "meetingEnding": "meetingEnding",
  "chooseCountry": "chooseCountry",
  "dialPhoneNumber": "dialPhoneNumber",
  "tollFree": "tollFree",
  "longDistance": "longDistance",
  "enterAccessCode": "enterAccessCode",
  "enterAudioNIP": "enterAudioNIP",
  "microphones": "microphones",
  "speakers": "speakers",
  "webcams": "webcams",
  "cameras": "cameras",
  "webcamFilter": "webcamFilter",
  "cameraFilter": "cameraFilter",
  "webcamPosition": "webcamPosition",
  "cameraPosition": "cameraPosition",
  "everyone": "everyone",
  "presenter": "presenter",
  "webcamsHidden": "webcamsHidden",
  "camerasHidden": "camerasHidden",
  "top": "top",
  "bottom": "bottom",
  "right": "right",
  "left": "left",
  "exit": "exit",
  "roomAudio": "roomAudio",
  "phoneCall": "phoneCall",
  "noAudio": "noAudio",
  "showTalking": "showTalking",
  "hearChimes": "hearChimes",
  "attendee": "attendee",
  "to": "to",
  "general": "general",
  "xMeeting": "xMeeting",
  "waitingForXToStartMeeting": "waitingForXToStartMeeting",
  "startIfOrganizer": "startIfOrganizer",
  "connecting": "connecting",
  "animationJoinTitle": "animationJoinTitle",
  "animationJoinSubtitle": "animationJoinSubtitle",
  "animationJoinContent": "animationJoinContent",
  "animationMeetTitle": "animationMeetTitle",
  "animationMeetSubtitle": "animationMeetSubtitle",
  "animationMeetContent": "animationMeetContent",
  "animationPresentTitle": "animationPresentTitle",
  "animationPresentSubtitle": "animationPresentSubtitle",
  "animationPresentContent": "animationPresentContent",
  "connectionHelpTitle": "connectionHelpTitle",
  "connectionHelpText1": "connectionHelpText1",
  "connectionHelpText2": "connectionHelpText2",
  "deviceId": "deviceId",
  "codec": "codec",
  "controller": "controller",
  "modelName": "modelName",
  "macAddress": "macAddress",
  "ipAddress": "ipAddress",
  "firmwareVersion": "firmwareVersion",
  "dialout_error_general": "dialout_error_general",
  "dialout_error_cancelOrVoicemail": "dialout_error_cancelOrVoicemail",
  "dialout_error_voicemail": "dialout_error_voicemail",
  "dialout_error_wrongNumber": "dialout_error_wrongNumber",
  "dialout_error_noResponse": "dialout_error_noResponse",
  "dialout_error_serviceDown": "dialout_error_serviceDown",
  "dialout_error_serviceDownWithDialin": "dialout_error_serviceDownWithDialin",
  "dialout_error_serviceDownWithVoip": "dialout_error_serviceDownWithVoip",
  "dialout_error_484": "dialout_error_484",
  "dialout_error_486": "dialout_error_486",
  "dialout_error_487": "dialout_error_487",
  "dialout_error_480": "dialout_error_480",
  "dialout_error_403": "dialout_error_403",
  "dialout_error_452": "dialout_error_452",
  "dialout_error_453": "dialout_error_453",
  "dialout_error_454": "dialout_error_454",
  "dialout_error_404": "dialout_error_404",
  "delegateMeetingDescription": "delegateMeetingDescription",
  "activateMeeting": "activateMeeting",
  "exitMeeting": "exitMeeting",
  "editNameMenuTitle": "editNameMenuTitle",
  "editNameHint": "editNameHint",
  "editNameEmailHint": "editNameEmailHint",
  "editNameJoinMeeting": "editNameJoinMeeting",
  "editNameValidityWarning": "editNameValidityWarning",
  "editNameEmailValidityWarning": "editNameEmailValidityWarning",
  "productName": "productName",
  "enterSenderName": "enterSenderName",
  "signInError": "signInError",
  "joinError": "joinError",
  "startError": "startError",
  "screenSharingInProgress": "screenSharingInProgress",
  "sendingInvitation": "sendingInvitation",
  "locallyMuted": "locallyMuted",
  "attendeeLocallyMuted": "attendeeLocallyMuted",
  "meetingOrganizers": "meetingOrganizers",
  "meetingAttendees": "meetingAttendees",
  "chatConversation": "chatConversation",
  "callMe": "callMe",
  "enterCallMeNumber": "enterCallMeNumber",
  "connectedToMeeting": "connectedToMeeting",
  "dial-in": "dial-in",
  "messageFromOrganizer": "messageFromOrganizer",
  "followConnectInstructions": "followConnectInstructions",
  "meetingPassword": "meetingPassword",
  "pleaseEnterPassword": "pleaseEnterPassword",
  "pleaseEnterMeetingPassword": "pleaseEnterMeetingPassword",
  "invalidPassword": "invalidPassword",
  "confirmPassword": "confirmPassword",
  "enterMatchingPassword": "enterMatchingPassword",
  "startTheMeeting": "startTheMeeting",
  "ifYouAreOrganizer": "ifYouAreOrganizer",
  "freePlanWarning": "freePlanWarning",
  "freePlanLimit": "freePlanLimit",
  "freePlanDescription": "freePlanDescription",
  "freePlanHint": "freePlanHint",
  "freePlanUpgrade": "freePlanUpgrade",
  "freeDismiss": "freeDismiss",
  "freeMeetingTimer": "freeMeetingTimer",
  "freeMeetingWebcamNotSupported": "freeMeetingWebcamNotSupported",
  "freeMeetingCameraNotSupported": "freeMeetingCameraNotSupported",
  "delegateMeetingTitle": "delegateMeetingTitle",
  "leaveSettingsWarningTitle": "leaveSettingsWarningTitle",
  "leaveSettingsWarningSubtitle": "leaveSettingsWarningSubtitle",
  "leaveSettingsWarningConfirm": "leaveSettingsWarningConfirm",
  "date": "date",
  "joinTheMeeting": "joinTheMeeting",
  "calling": "calling",
  "startIfOrganizerWithLink": "startIfOrganizerWithLink",
  "organizerRecording": "organizerRecording",
  "organizerRecordingCamera": "organizerRecordingCamera",
  "onlyOrganizersRecord": "onlyOrganizersRecord",
  "waitingForXToUnlockTheMeeting": "waitingForXToUnlockTheMeeting",
  "areYouXSignIn": "areYouXSignIn",
  "muteAll": "muteAll",
  "unmuteAll": "unmuteAll",
  "tzPacificTongatapu": "tzPacificTongatapu",
  "tzPacificFiji": "tzPacificFiji",
  "tzPacificAuckland": "tzPacificAuckland",
  "tzAsiaMagadan": "tzAsiaMagadan",
  "tzAustraliaCurrie": "tzAustraliaCurrie",
  "tzAsiaVladivostok": "tzAsiaVladivostok",
  "tzAustraliaHobart": "tzAustraliaHobart",
  "tzPacificGuam": "tzPacificGuam",
  "tzAustraliaSydney": "tzAustraliaSydney",
  "tzAustraliaBrisbane": "tzAustraliaBrisbane",
  "tzAustraliaDarwin": "tzAustraliaDarwin",
  "tzAustraliaAdelaide": "tzAustraliaAdelaide",
  "tzAsiaYakutsk": "tzAsiaYakutsk",
  "tzAsiaSeoul": "tzAsiaSeoul",
  "tzAsiaTokyo": "tzAsiaTokyo",
  "tzAsiaTaipei": "tzAsiaTaipei",
  "tzAustraliaPerth": "tzAustraliaPerth",
  "tzAsiaSingapore": "tzAsiaSingapore",
  "tzAsiaIrkutsk": "tzAsiaIrkutsk",
  "tzAsiaShanghai": "tzAsiaShanghai",
  "tzAsiaKrasnoyarsk": "tzAsiaKrasnoyarsk",
  "tzAsiaBangkok": "tzAsiaBangkok",
  "tzAsiaJakarta": "tzAsiaJakarta",
  "tzAsiaRangoon": "tzAsiaRangoon",
  "tzAsiaColombo": "tzAsiaColombo",
  "tzAsiaDhaka": "tzAsiaDhaka",
  "tzAsiaNovosibirsk": "tzAsiaNovosibirsk",
  "tzAsiaKatmandu": "tzAsiaKatmandu",
  "tzAsiaCalcutta": "tzAsiaCalcutta",
  "tzAsiaKarachi": "tzAsiaKarachi",
  "tzAsiaYekaterinburg": "tzAsiaYekaterinburg",
  "tzAsiaKabul": "tzAsiaKabul",
  "tzAsiaTbilisi": "tzAsiaTbilisi",
  "tzAsiaMuscat": "tzAsiaMuscat",
  "tzAsiaTehran": "tzAsiaTehran",
  "tzAfricaNairobi": "tzAfricaNairobi",
  "tzEuropeMoscow": "tzEuropeMoscow",
  "tzAsiaKuwait": "tzAsiaKuwait",
  "tzAsiaBaghdad": "tzAsiaBaghdad",
  "tzAsiaJerusalem": "tzAsiaJerusalem",
  "tzEuropeHelsinki": "tzEuropeHelsinki",
  "tzAfricaHarare": "tzAfricaHarare",
  "tzAfricaCairo": "tzAfricaCairo",
  "tzEuropeBucharest": "tzEuropeBucharest",
  "tzEuropeAthens": "tzEuropeAthens",
  "tzAfricaMalabo": "tzAfricaMalabo",
  "tzEuropeWarsaw": "tzEuropeWarsaw",
  "tzEuropeBrussels": "tzEuropeBrussels",
  "tzEuropePrague": "tzEuropePrague",
  "tzEuropeAmsterdam": "tzEuropeAmsterdam",
  "tzGMT": "tzGMT",
  "tzAfricaCasablanca": "tzAfricaCasablanca",
  "tzAtlanticCape_Verde": "tzAtlanticCape_Verde",
  "tzAtlanticAzores": "tzAtlanticAzores",
  "tzAmericaBuenos_Aires": "tzAmericaBuenos_Aires",
  "tzAmericaSao_Paulo": "tzAmericaSao_Paulo",
  "tzAmericaSt_Johns": "tzAmericaSt_Johns",
  "tzAmericaSantiago": "tzAmericaSantiago",
  "tzAmericaCaracas": "tzAmericaCaracas",
  "tzAmericaHalifax": "tzAmericaHalifax",
  "tzAmericaIndianapolis": "tzAmericaIndianapolis",
  "tzAmericaNew_York": "tzAmericaNew_York",
  "tzAmericaBogota": "tzAmericaBogota",
  "tzAmericaMexico_City": "tzAmericaMexico_City",
  "tzAmericaGuatemala": "tzAmericaGuatemala",
  "tzAmericaChicago": "tzAmericaChicago",
  "tzAmericaDenver": "tzAmericaDenver",
  "tzAmericaPhoenix": "tzAmericaPhoenix",
  "tzAmericaLos_Angeles": "tzAmericaLos_Angeles",
  "tzAmericaAnchorage": "tzAmericaAnchorage",
  "tzPacificHonolulu": "tzPacificHonolulu",
  "tzMIT": "tzMIT",
  "tzPacificMidway": "tzPacificMidway",
  "tzEuropeLondon": "tzEuropeLondon",
  "meetingLinkAndNumbers": "meetingLinkAndNumbers",
  "meetingLink": "meetingLink",
  "meetingJoinInfo": "meetingJoinInfo",
  "unitedStates": "unitedStates",
  "inABrowser": "inABrowser",
  "noDeviceDetected": "noDeviceDetected",
  "pleaseWait": "pleaseWait",
  "status": "status",
  "error": "error",
  "organizerRecordingStarted": "organizerRecordingStarted",
  "organizerRecordingPaused": "organizerRecordingPaused",
  "organizerRecordingActivated": "organizerRecordingActivated",
  "dontWantRecording": "dontWantRecording",
  "noMeetNowRecording": "noMeetNowRecording",
  "onlyOrganizerControlRecording": "onlyOrganizerControlRecording",
  "onlyOrganizerResumeRecording": "onlyOrganizerResumeRecording",
  "recordingStopHint": "recordingStopHint",
  "recordingUnavailableOrganizerLeft": "recordingUnavailableOrganizerLeft",
  "organizerRecordingActive": "organizerRecordingActive",
  "organizerRecordingPause": "organizerRecordingPause",
  "howRecordingWorks": "howRecordingWorks",
  "meetingRecordingModalTitle": "meetingRecordingModalTitle",
  "meetingRecordingModalText1": "meetingRecordingModalText1",
  "meetingRecordingModalText2": "meetingRecordingModalText2",
  "meetingRecordingModalText3": "meetingRecordingModalText3",
  "genericDialogTitle": "genericDialogTitle",
  "genericDialogText": "genericDialogText",
  "timeFormatLabel": "timeFormatLabel",
  "12HourTime": "12HourTime",
  "24HourTime": "24HourTime",
  "surveyTitle": "surveyTitle",
  "surveyAgree": "surveyAgree",
  "surveyDisagree": "surveyDisagree",
  "surveySkip": "surveySkip",
  "surveyPlaceholder": "surveyPlaceholder",
  "openSourceLink": "openSourceLink",
  "done": "done",
  "gotoconnectid": "gotoconnectid",
  "activeCameras": "activeCameras",
  "noInputDevice": "noInputDevice",
  "noOutputDevice": "noOutputDevice",
  "noVideoDevice": "noVideoDevice",
  "presentPause": "presentPause",
  "presentResume": "presentResume",
  "presentEscalate": "presentEscalate",
  "presentStop": "presentStop",
  "presenterModalTabletTitle": "presenterModalTabletTitle",
  "dolbyConnectionHelpTitle": "dolbyConnectionHelpTitle",
  "dolbyConnectionHelpText1": "dolbyConnectionHelpText1",
  "unlockTooltip": "unlockTooltip",
  "noCameraConnected": "noCameraConnected",
  "noInputConnected": "noInputConnected",
  "noOutputConnected": "noOutputConnected",
  "noPresenterRights": "noPresenterRights",
  "presenterRightsChanged": "presenterRightsChanged",
  "roomMadeAsPresenter": "roomMadeAsPresenter",
  "usewhiteboardForSharing": "usewhiteboardForSharing",
  "useHdmiForSharing": "useHdmiForSharing",
  "useWifiForSharing": "useWifiForSharing",
  "screenSharingOptions": "screenSharingOptions",
  "whiteboard": "whiteboard",
  "hdmiCable": "hdmiCable",
  "wireless": "wireless",
  "wirelessSharingTitle": "wirelessSharingTitle",
  "stopSharing": "stopSharing",
  "settingsSaved": "settingsSaved",
  "requestPresenterRights": "requestPresenterRights",
  "g2mCrashedToastText": "g2mCrashedToastText",
  "activeSpeaker": "activeSpeaker",
  "vendormeetid": "vendormeetid",
  "hdmicontentSharingReadyTitle": "hdmicontentSharingReadyTitle",
  "hdmicontentSharingReadyText": "hdmicontentSharingReadyText",
  "hdmicontentSharingInstructionTitle": "hdmicontentSharingInstructionTitle",
  "hdmicontentSharingInstructionOptionOne": "hdmicontentSharingInstructionOptionOne",
  "hdmicontentSharingInstructionOptionTwo": "hdmicontentSharingInstructionOptionTwo",
  "hdmiCablePlugedInstruction": "hdmiCablePlugedInstruction",
  "inSessionSecondScreenNoSharingNUCTitle": "inSessionSecondScreenNoSharingNUCTitle",
  "inSessionSecondScreenNoSharingNUCText1": "inSessionSecondScreenNoSharingNUCText1",
  "inSessionSecondScreenNoSharingDVRTitle": "inSessionSecondScreenNoSharingDVRTitle",
  "inSessionSecondScreenNoSharingDVRText1": "inSessionSecondScreenNoSharingDVRText1",
  "inSessionSecondScreenNoSharingDVRTitleHDMI": "inSessionSecondScreenNoSharingDVRTitleHDMI",
  "inSessionSecondScreenNoSharingDVRTitleWireless": "inSessionSecondScreenNoSharingDVRTitleWireless",
  "inSessionSecondScreenNoSharingDVRTextWhiteboard": "inSessionSecondScreenNoSharingDVRTextWhiteboard",
  "inSessionSecondScreenNoSharingDVRTextHDMI": "inSessionSecondScreenNoSharingDVRTextHDMI",
  "inSessionSecondScreenNoSharingDVRTextWireless": "inSessionSecondScreenNoSharingDVRTextWireless",
  "share": "share",
  "notPresenterTitle": "notPresenterTitle",
  "notPresenterContent": "notPresenterContent",
  "notPresenterAutoRequestTitle": "notPresenterAutoRequestTitle",
  "notPresenterAutoRequestContent": "notPresenterAutoRequestContent",
  "swapMonitorPosition": "swapMonitorPosition",
  "dualScreenHelpTitle": "dualScreenHelpTitle",
  "dualScreenHelpSubTitle": "dualScreenHelpSubTitle",
  "hdmiShareTitle": "hdmiShareTitle",
  "hdmiShareSubTitle": "hdmiShareSubTitle",
  "wirelesslyTitle": "wirelesslyTitle",
  "wirelesslySubTitle": "wirelesslySubTitle",
  "layoutOptions": "layoutOptions",
  "dualScreenExtendedHint": "dualScreenExtendedHint",
  "dualScreenSwapHelp": "dualScreenSwapHelp",
  "dualScreenArrangement": "dualScreenArrangement",
  "thirdPartyNameBluejeans": "thirdPartyNameBluejeans",
  "thirdPartyNameHangout": "thirdPartyNameHangout",
  "thirdPartyNameZoom": "thirdPartyNameZoom",
  "thirdPartyNameWebex": "thirdPartyNameWebex",
  "thirdPartyNameTeams": "thirdPartyNameTeams",
  "thirdPartySubtitleBluejeans": "thirdPartySubtitleBluejeans",
  "thirdPartySubtitleHangout": "thirdPartySubtitleHangout",
  "thirdPartySubtitleZoom": "thirdPartySubtitleZoom",
  "thirdPartySubtitleWebex": "thirdPartySubtitleWebex",
  "thirdPartySubtitleTeams": "thirdPartySubtitleTeams",
  "thirdPartyJoinTitle": "thirdPartyJoinTitle",
  "thirdPartyJoinInfo": "thirdPartyJoinInfo",
  "tpMeetingInfoTitle": "tpMeetingInfoTitle",
  "tpMeetingInfoHint": "tpMeetingInfoHint",
  "tpInputPlaceholder": "tpInputPlaceholder",
  "welcomeScreenTitle": "welcomeScreenTitle",
  "welcomeScreenText": "welcomeScreenText",
  "seeUpcomingMeetings": "seeUpcomingMeetings",
  "linkCalendar": "linkCalendar",
  "meetingStartsInMinute": "meetingStartsInMinute",
  "meetingStartsInMinute_plural": "meetingStartsInMinute_plural",
  "roomAvailable": "roomAvailable",
  "calendar": "calendar",
  "joinOrStart": "joinOrStart",
  "shareScreen": "shareScreen",
  "phone": "phone",
  "noMeetingPlanned": "noMeetingPlanned",
  "meetingOrganizer": "meetingOrganizer",
  "meetingId": "meetingId",
  "startingInMinutes": "startingInMinutes",
  "startingInMinutes_plural": "startingInMinutes_plural",
  "joinOrStartMeeting": "joinOrStartMeeting",
  "enterMeetingId": "enterMeetingId",
  "hallway_waiting": "hallway_waiting",
  "hallway_locked": "hallway_locked",
  "hallway_enterPassword": "hallway_enterPassword",
  "hallway_setPassword": "hallway_setPassword",
  "duration": "duration",
  "recurrent": "recurrent",
  "invitees": "invitees",
  "durationMinute": "durationMinute",
  "durationMinute_plural": "durationMinute_plural",
  "durationHourAndMinute": "durationHourAndMinute",
  "durationHourAndMinute_plural": "durationHourAndMinute_plural",
  "durationHoursAndMinute": "durationHoursAndMinute",
  "durationHoursAndMinute_plural": "durationHoursAndMinute_plural",
  "durationHour": "durationHour",
  "durationHour_plural": "durationHour_plural",
  "shareScreenTitle": "shareScreenTitle",
  "shareScreenTitleTouch": "shareScreenTitleTouch",
  "shareScreenWirelessSubtitle": "shareScreenWirelessSubtitle",
  "shareScreenWirelessOptionSubtitle": "shareScreenWirelessOptionSubtitle",
  "shareScreenSubtitleTouch": "shareScreenSubtitleTouch",
  "offlineAlertTitle": "offlineAlertTitle",
  "offlineAlertSubtitle": "offlineAlertSubtitle",
  "thirdPartyLegalNotice": "thirdPartyLegalNotice",
  "meetingType": "meetingType",
  "touchDisconnectedTitle": "touchDisconnectedTitle",
  "touchDisconnectedTitleDVH": "touchDisconnectedTitleDVH",
  "touchDisconnectedTitleDVR": "touchDisconnectedTitleDVR",
  "touchDisconnectedSubtitle": "touchDisconnectedSubtitle",
  "touchDisconnectedSubtitleDVH": "touchDisconnectedSubtitleDVH",
  "touchDisconnectedSubtitleDVR": "touchDisconnectedSubtitleDVR",
  "inSessionSecondScreenNoSharingDVRFooter": "inSessionSecondScreenNoSharingDVRFooter",
  "tapWake": "tapWake",
  "by": "by",
  "createInstant": "createInstant",
  "conferenceRoom": "conferenceRoom",
  "systemAvailable": "systemAvailable",
  "startBlank": "startBlank",
  "chooseLanguage": "chooseLanguage",
  "chooseRegion": "chooseRegion",
  "canada": "canada",
  "australia": "australia",
  "ireland": "ireland",
  "austria": "austria",
  "netherlands": "netherlands",
  "sweden": "sweden",
  "france": "france",
  "italy": "italy",
  "spain": "spain",
  "portugal": "portugal",
  "poland": "poland",
  "czechRepublic": "czechRepublic",
  "slovakia": "slovakia",
  "romania": "romania",
  "greece": "greece",
  "cyprus": "cyprus",
  "unitedKingdom": "unitedKingdom",
  "germany": "germany",
  "belgium": "belgium",
  "luxembourg": "luxembourg",
  "denmark": "denmark",
  "finland": "finland",
  "iceland": "iceland",
  "norway": "norway",
  "switzerland": "switzerland",
  "hungary": "hungary",
  "slovenia": "slovenia",
  "latvia": "latvia",
  "estonia": "estonia",
  "lithuania": "lithuania",
  "croatia": "croatia",
  "bulgaria": "bulgaria",
  "malta": "malta",
  "nameRoom": "nameRoom",
  "twoDisplaysDetected": "twoDisplaysDetected",
  "respectOrder": "respectOrder",
  "isArrangmentCorrect": "isArrangmentCorrect",
  "swapScreens": "swapScreens",
  "selectDefaultTheme": "selectDefaultTheme",
  "light": "light",
  "dark": "dark",
  "customization": "customization",
  "dateTime": "dateTime",
  "adjustCamera": "adjustCamera",
  "accessibility": "accessibility",
  "roomName": "roomName",
  "systemLanguage": "systemLanguage",
  "region": "region",
  "keyboardLayout": "keyboardLayout",
  "moreSettings": "moreSettings",
  "calendarIntegration": "calendarIntegration",
  "linkACalendar": "linkACalendar",
  "customWallpaper": "customWallpaper",
  "uploadWallpaper": "uploadWallpaper",
  "multiroomManagment": "multiroomManagment",
  "manageRemotely": "manageRemotely",
  "version": "version",
  "copyrights": "copyrights",
  "restartAndUpdate": "restartAndUpdate",
  "cameraOn": "cameraOn",
  "cameraOff": "cameraOff",
  "advanced": "advanced",
  "platformSettingsTitle": "platformSettingsTitle",
  "showSettings": "showSettings",
  "brightness": "brightness",
  "contrast": "contrast",
  "saturation": "saturation",
  "meetingIsLocked": "meetingIsLocked",
  "meetingLockedLogin": "meetingLockedLogin",
  "mirror": "mirror",
  "extended": "extended",
  "plugSecondDisplay": "plugSecondDisplay",
  "shareContent": "shareContent",
  "shareContentWirelessly": "shareContentWirelessly",
  "shareContentWirelesslyBrowsers": "shareContentWirelesslyBrowsers",
  "shareContentWirelesslyOpenBrowser": "shareContentWirelesslyOpenBrowser",
  "shareContentWirelesslyTypeUrl": "shareContentWirelesslyTypeUrl",
  "shareContentWirelesslyConnected": "shareContentWirelesslyConnected",
  "shareWirelessOpenBrowser": "shareWirelessOpenBrowser",
  "shareHDMI": "shareHDMI",
  "shareHDMIConnected": "shareHDMIConnected",
  "shareWhiteboardUseCamera": "shareWhiteboardUseCamera",
  "shareHDMISubtitle": "shareHDMISubtitle",
  "noInputSource": "noInputSource",
  "startSharing": "startSharing",
  "boxNotPresenter": "boxNotPresenter",
  "enableHDR": "enableHDR",
  "HDRDescription": "HDRDescription",
  "tapClicks": "tapClicks",
  "meetingID": "meetingID",
  "startedAt": "startedAt",
  "timeRemaining": "timeRemaining",
  "recurring": "recurring",
  "attendees": "attendees",
  "keyboardClicks": "keyboardClicks",
  "tabletTheme": "tabletTheme",
  "timeSinceStart": "timeSinceStart",
  "justNow": "justNow",
  "noInputDeviceTitle": "noInputDeviceTitle",
  "noOutputDeviceTitle": "noOutputDeviceTitle",
  "noVideoDeviceTitle": "noVideoDeviceTitle",
  "startErrorTitle": "startErrorTitle",
  "systemSounds": "systemSounds",
  "selectATimezone": "selectATimezone",
  "timeOptions": "timeOptions",
  "use24HourFormat": "use24HourFormat",
  "flashTimeSeparator": "flashTimeSeparator",
  "roomMeetingName": "roomMeetingName",
  "startThisMeeting": "startThisMeeting",
  "joinThisMeeting": "joinThisMeeting",
  "forTheRestOfDay": "forTheRestOfDay",
  "forHourAndMinute": "forHourAndMinute",
  "forHourAndMinute_plural": "forHourAndMinute_plural",
  "forHoursAndMinute": "forHoursAndMinute",
  "forHoursAndMinutes": "forHoursAndMinutes",
  "forMinute": "forMinute",
  "forMinute_plural": "forMinute_plural",
  "forHour": "forHour",
  "forHour_plural": "forHour_plural",
  "people": "people",
  "invitePeople": "invitePeople",
  "meetingLocked": "meetingLocked",
  "meetingUnlocked": "meetingUnlocked",
  "meetingLockedHelp": "meetingLockedHelp",
  "peopleModeDescription": "peopleModeDescription",
  "ptzDescription": "ptzDescription",
  "hubAppVersion": "hubAppVersion",
  "touchPanelVersion": "touchPanelVersion",
  "controlAppVersion": "controlAppVersion",
  "displayAppVersion": "displayAppVersion",
  "roomNameLengthError": "roomNameLengthError",
  "phoneNotConfigured": "phoneNotConfigured",
  "presetLabel": "presetLabel",
  "cameraTabPresets": "cameraTabPresets",
  "cameraModeRoomLabel": "cameraModeRoomLabel",
  "inviteOnePerson": "inviteOnePerson",
  "cameraModePeopleLabel": "cameraModePeopleLabel",
  "micOn": "micOn",
  "micOff": "micOff",
  "adjust": "adjust",
  "details": "details",
  "peopleLabel": "peopleLabel",
  "peopleLabelCount": "peopleLabelCount",
  "chat": "chat",
  "inviteNPeople": "inviteNPeople",
  "record": "record",
  "settings": "settings",
  "createPassword": "createPassword",
  "createPasswordDescription": "createPasswordDescription",
  "passwordProtectedTitle": "passwordProtectedTitle",
  "enterPasswordDescription": "enterPasswordDescription",
  "thirdPartyJoinSubtitle": "thirdPartyJoinSubtitle",
  "joinWithMeetingIdOrName": "joinWithMeetingIdOrName",
  "joinGoToMeetings": "joinGoToMeetings",
  "roomAvailableFor": "roomAvailableFor",
  "zoom": "zoom",
  "organizedBy": "organizedBy",
  "inSessionGeneralSettingSubtitle": "inSessionGeneralSettingSubtitle",
  "userRoomAudio": "userRoomAudio",
  "roomAudioDescription": "roomAudioDescription",
  "enterNumber": "enterNumber",
  "connectedOn": "connectedOn",
  "sendTo": "sendTo",
  "sendToOrganizer": "sendToOrganizer",
  "sendToPresenter": "sendToPresenter",
  "sendToEveryone": "sendToEveryone",
  "thisRoom": "thisRoom",
  "thisRoomTarget": "thisRoomTarget",
  "chatTargets": "chatTargets",
  "argentina": "argentina",
  "bahrain": "bahrain",
  "belarus": "belarus",
  "brazil": "brazil",
  "chile": "chile",
  "china": "china",
  "colombia": "colombia",
  "hongKong": "hongKong",
  "india": "india",
  "indonesia": "indonesia",
  "israel": "israel",
  "japan": "japan",
  "korea": "korea",
  "malaysia": "malaysia",
  "mexico": "mexico",
  "newZealand": "newZealand",
  "panama": "panama",
  "peru": "peru",
  "philippines": "philippines",
  "russia": "russia",
  "saudiArabia": "saudiArabia",
  "singapore": "singapore",
  "southAfrica": "southAfrica",
  "taiwan": "taiwan",
  "thailand": "thailand",
  "turkey": "turkey",
  "ukraine": "ukraine",
  "arabEmirates": "arabEmirates",
  "vietnam": "vietnam",
  "uruguay": "uruguay",
  "view": "view",
  "leaveMeeting": "leaveMeeting",
  "endMeetingForAll": "endMeetingForAll",
  "sharedContent": "sharedContent",
  "unlockButton": "unlockButton",
  "attendeeJoinsLockedMeeting": "attendeeJoinsLockedMeeting",
  "today": "today",
  "dateNew": "dateNew",
  "accept": "accept",
  "refuse": "refuse",
  "deny": "deny",
  "dcpNpaTitle": "dcpNpaTitle",
  "npaDescriptionPartOne": "npaDescriptionPartOne",
  "npaDescriptionPartTwo": "npaDescriptionPartTwo",
  "npaDescriptionPartThree": "npaDescriptionPartThree",
  "controllerNpaTitle": "controllerNpaTitle",
  "raiseHand": "raiseHand",
  "handRaised": "handRaised",
  "webinarInfo": "webinarInfo",
  "webinarId": "webinarId",
  "pollAnswersSubmitted": "pollAnswersSubmitted",
  "selectOneOrMore": "selectOneOrMore",
  "selectOne": "selectOne",
  "selectOneOrMoreTablet": "selectOneOrMoreTablet",
  "selectOneTablet": "selectOneTablet",
  "pollResults": "pollResults",
  "unlicensedJoinTitle": "unlicensedJoinTitle",
  "unlicensedJoinSubTitle": "unlicensedJoinSubTitle",
  "unlicensedTvTitle": "unlicensedTvTitle",
  "unlicensedTvDescription": "unlicensedTvDescription",
  "unlicensedTvJoinTitle": "unlicensedTvJoinTitle",
  "unlicensedTvScreenSharingTitle": "unlicensedTvScreenSharingTitle",
  "unlicensedTvScreenSharingDescription": "unlicensedTvScreenSharingDescription",
  "unlicensedTvThirdPartyTitle": "unlicensedTvThirdPartyTitle",
  "unlicensedTvThirdPartyDescription": "unlicensedTvThirdPartyDescription",
  "unlicensedTvJoinDescription": "unlicensedTvJoinDescription",
  "existingCustomerOption": "existingCustomerOption",
  "existingCustomerLinkText": "existingCustomerLinkText",
  "existingCustomerTitle": "existingCustomerTitle",
  "existingCustomerDescription": "existingCustomerDescription",
  "newCustomerOption": "newCustomerOption",
  "newCustomerLinkText": "newCustomerLinkText",
  "newCustomerTitleOne": "newCustomerTitleOne",
  "newCustomerDescriptionOne": "newCustomerDescriptionOne",
  "newCustomerTitleTwo": "newCustomerTitleTwo",
  "newCustomerDescriptionTwo": "newCustomerDescriptionTwo",
  "deviceLinkedTitle": "deviceLinkedTitle",
  "deviceLinkedDescription": "deviceLinkedDescription",
  "thirdPartyNameOtherSIP": "thirdPartyNameOtherSIP",
  "thirdPartyBubbleSubtitleTeams": "thirdPartyBubbleSubtitleTeams",
  "thirdPartyBubbleSubtitleWebex": "thirdPartyBubbleSubtitleWebex",
  "thirdPartyBubbleSubtitleZoom": "thirdPartyBubbleSubtitleZoom",
  "thirdPartyBubbleSubtitleBluejeans": "thirdPartyBubbleSubtitleBluejeans",
  "thirdPartyBubbleSubtitleHangouts": "thirdPartyBubbleSubtitleHangouts",
  "thirdPartySIPTeamsTitle": "thirdPartySIPTeamsTitle",
  "thirdPartySIPZoomTitle": "thirdPartySIPZoomTitle",
  "thirdPartySIPWebexTitle": "thirdPartySIPWebexTitle",
  "thirdPartySIPOtherSIPTitle": "thirdPartySIPOtherSIPTitle",
  "thirdPartyFullSIPSubtitle": "thirdPartyFullSIPSubtitle",
  "thirdPartyOnlyIDSIPSubtitle": "thirdPartyOnlyIDSIPSubtitle",
  "thirdPartySIPTeamsHint": "thirdPartySIPTeamsHint",
  "thirdPartySIPZoomHint": "thirdPartySIPZoomHint",
  "thirdPartySIPWebexHint": "thirdPartySIPWebexHint",
  "thirdPartySIPOtherSIPHint": "thirdPartySIPOtherSIPHint",
  "whiteboardNotEnrolled": "whiteboardNotEnrolled",
  "whiteboardNotEnrolledDesc": "whiteboardNotEnrolledDesc",
  "gotIt": "gotIt",
  "activationFormTitle": "activationFormTitle",
  "activationFormDescription": "activationFormDescription",
  "support": "support",
  "success": "success",
  "activationSuccessDesc": "activationSuccessDesc",
  "deviceCode": "deviceCode",
  "addDevice": "addDevice",
  "invalidCode": "invalidCode",
  "joinOnlyTitle": "joinOnlyTitle",
  "joinOnlySubTitle": "joinOnlySubTitle",
  "addedFeatures": "addedFeatures",
  "hostYourMeetings": "hostYourMeetings",
  "sharePresentations": "sharePresentations",
  "syncRoomToCalendar": "syncRoomToCalendar",
  "signOut": "signOut",
  "activationErrorTitle": "activationErrorTitle",
  "activationErrorMessage": "activationErrorMessage",
  "activationUnknownErrorTitle": "activationUnknownErrorTitle",
  "activationUnknownErrorMessage": "activationUnknownErrorMessage",
  "contactMyAdmin": "contactMyAdmin",
  "selectYourAccount": "selectYourAccount",
  "selectAccount": "selectAccount",
  "unableToJoinWebinar": "unableToJoinWebinar",
  "webcastNotSupportedOnThisDevice": "webcastNotSupportedOnThisDevice",
  "organizerMadeRoomPanelist": "organizerMadeRoomPanelist",
  "meetingFeaturesNotSupportedTitle": "meetingFeaturesNotSupportedTitle",
  "meetingFeaturesNotSupportedText": "meetingFeaturesNotSupportedText",
  "deviceModeJoinTitle": "deviceModeJoinTitle",
  "deviceModeJoinSubtitle": "deviceModeJoinSubtitle",
  "deviceModeInstructionsHeader1": "deviceModeInstructionsHeader1",
  "deviceModeInstructionsHeader2": "deviceModeInstructionsHeader2",
  "deviceModeInstructionsUsb": "deviceModeInstructionsUsb",
  "deviceModeInstructionsHdmi": "deviceModeInstructionsHdmi",
  "deviceModeInstructionsStart": "deviceModeInstructionsStart",
  "deviceModeInstructionsStop": "deviceModeInstructionsStop",
  "deviceModeInstructionsFooter": "deviceModeInstructionsFooter",
  "phoneExtensionShort": "phoneExtensionShort",
  "phoneExtension": "phoneExtension",
  "phoneConfigureHint": "phoneConfigureHint",
  "phoneTitle": "phoneTitle",
  "phoneConnecting": "phoneConnecting",
  "phoneIncomingCall": "phoneIncomingCall",
  "phoneAcceptCall": "phoneAcceptCall",
  "phoneDeclineCall": "phoneDeclineCall",
  "phoneKeypad": "phoneKeypad",
  "phoneHold": "phoneHold",
  "phoneResume": "phoneResume",
  "phoneIncomingToastText": "phoneIncomingToastText"
}
/* tslint:enable */
